import React from "react";

/**
 * SiteBackground — v3.
 * One rotated wrapper (45°) with many rows of repeating "DUUNARI" text.
 * Each row scrolls horizontally; odd rows go right, even rows go left,
 * alternating cleanly so they never collide visually.
 */
export const SiteBackground = () => {
  const phrase =
    "DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · DUUNARI · ";
  // Duplicate inside each row for seamless looping
  const line = phrase.repeat(2);
  // Mixed durations create organic, non-mechanical motion
  const durations = [80, 110, 95, 130, 100, 90, 120, 105, 85, 115, 100, 95, 125, 90, 110, 100, 95, 105];
  const rows = durations.map((dur, i) => ({
    dir: i % 2 === 0 ? "right" : "left",
    neon: i % 3 === 1, // every third row is neon-tinted
    dur,
  }));

  return (
    <div
      aria-hidden="true"
      data-testid="site-background"
      className="fixed inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 0 }}
    >
      <div className="site-bg-stage">
        {rows.map((r, i) => (
          <div
            key={i}
            className={`site-bg-row ${r.neon ? "site-bg-row-neon" : "site-bg-row-white"}`}
          >
            <div
              className={`site-bg-track ${r.dir === "right" ? "site-bg-right" : "site-bg-left"}`}
              style={{ animationDuration: `${r.dur}s` }}
            >
              {line}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
